<template>
  <div>
    <h4>
      {{ $t(`questions.basicInformation.existingCertifications`) }}
    </h4>
    <div class="row header mt-3">
      <div class="col-2 tableCol d-flex justify-content-center align-items-center">
        {{ $t(`questions.basicInformation.existingCertificationsNumber`) }}
      </div>
      <div class="col-3 tableCol d-flex justify-content-center align-items-center">
        {{ $t(`questions.basicInformation.existingCertificationsRevision`) }}
      </div>
      <div class="col-3 tableCol d-flex justify-content-center align-items-center">
        {{ $t(`questions.basicInformation.existingCertificationsTopic`) }}
      </div>
      <div class="col-3 tableCol d-flex justify-content-center align-items-center">
        {{ $t(`questions.basicInformation.existingCertificationsValidUntil`) }}
      </div>
      <div class="col-1 tableCol d-flex justify-content-center align-items-center"></div>
    </div>
    <div v-for="(item, index) in existingCertifications" :key="index" class="row mt-2">
      <div class="col-2">
        <input v-model="item.number" type="text" class="form-control" :disabled="isReleased" @change="updateValue" />
      </div>
      <div class="col-3">
        <input v-model="item.revision" type="text" class="form-control" :disabled="isReleased" @change="updateValue" />
      </div>
      <div class="col-3">
        <input v-model="item.topic" type="text" class="form-control" :disabled="isReleased" @change="updateValue" />
      </div>
      <div class="col-3">
        <input v-model="item.validUntil" type="text" class="form-control" :disabled="isReleased" @change="updateValue" />
      </div>
      <div class="col-1">
        <button type="button" :title="$t(`buttons.delete`)" class="btn btn-primary btn-small" @click="deleteRow(index)">
          <i class="far fa-trash-alt"></i>
        </button>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <button type="button" class="btn btn-primary" :disabled="isReleased" @click="addRow()">
          <i class="far fa-plus"></i>
          {{ $t(`messages.info.hoverButtonAdd`) }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import UserInfoStore from '../../auth/user-info-store';
import constants from '../../common/constants';
import UserApi from '../../services/api/user';

export default {
  name: 'SupplierEvaluationCertificates',
  props: {
    certificates: {
      type: Array,
      default: () => []
    },
    isReleased: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      existingCertifications: []
    };
  },
  mounted() {
    this.existingCertifications = Object.assign([], this.certificates);
    if (this.existingCertifications.length === 0) {
      this.addRow();
    }
  },
  methods: {
    addRow() {
      this.existingCertifications.push({ number: '', revision: '', topic: '', validUntil: '' });
    },
    deleteRow(index) {
      this.existingCertifications.splice(index, 1);
      this.$emit('certificatesUpdate', this.existingCertifications);
    },
    updateValue() {
      this.$emit('certificatesUpdate', this.existingCertifications);
    }
  }
};
</script>
<style scoped>
.header {
  background-color: var(--primary);
  color: white;
  background-clip: content-box;
  padding-left: 15px;
  padding-right: 15px;
}

.tableCol {
  height: 40px;
}

.no-margin {
  margin: 0;
}
</style>
